import { Stack, Typography } from "@mui/material";
import { T } from "../../util/t";
import { Link } from "react-router-dom";
import { SeriesMembershipsOpen } from "./SeriesMembershipsOpen";
import { EntriesOpen } from "./EntriesOpen";
import { Live } from "./Live";
import { ScrollWithShadows } from "../utils/ScrollWithShadows";
import { useOrganisationStyles } from "./useOrganisationStyles";
import { Results } from "./Results";
import { ISO_DATE } from "../../../utils/dates";
import { sortByDateAscending, sortByDateDescending } from "../../../utils/sort";
import dayjs from "dayjs";

export const Highlights = ({ organisation }) => {
    const classes = useOrganisationStyles();
    const openSeries = organisation.series.filter(series => series.signOnStatus === "open");
    const hasOpenSeries = openSeries?.length > 0;
    const today = dayjs().format(ISO_DATE);
    const upcomingEvents = organisation.events.filter(event => event.status === "upcoming" && event.date > today).sort(sortByDateAscending);
    const hasUpcomingEvents = upcomingEvents?.length > 0;
    const liveEvents = organisation.events.filter(event => event.status === "on");
    const hasLiveEvents = liveEvents?.length > 0;
    const completedEvents = organisation.events.filter(event => event.status === "finished" || event.status === "results_published").sort(sortByDateDescending);
    const hasCompletedEvents = completedEvents?.length > 0;
    const showHighlights =  hasLiveEvents || hasUpcomingEvents || hasCompletedEvents || hasOpenSeries;

    if (!showHighlights) return null;

    return (
        <section className={classes.section}>
            <Typography variant="h7" component="h2" className={classes.title}><T>Highlights</T></Typography>
            <ScrollWithShadows className={classes.highlights}>
                {hasLiveEvents && <Live events={liveEvents}/>}
                {hasUpcomingEvents && <EntriesOpen event={upcomingEvents[0]}/>}
                {hasCompletedEvents && <Results event={completedEvents[0]} />}
                {hasOpenSeries && <SeriesMembershipsOpen organisation={organisation} openSeries={openSeries}/>}
            </ScrollWithShadows>
        </section>
    );
};

export const HighlightCard = ({ icon, status, text, name, to, ...rest }) => (
    <Stack spacing={0.5} component={Link} borderRadius={1} flexShrink={0} minWidth={theme => theme.spacing(22.5)} maxWidth={theme => theme.spacing(35)} marginRight={2} padding={1.5} to={to} {...rest}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography display="flex">{icon}</Typography>
            <Typography whiteSpace="nowrap" variant="label2" textTransform="uppercase"><T>{text}</T></Typography>
        </Stack>
        <Typography variant="body2" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">{name}</Typography>
    </Stack>
);
